import { render, staticRenderFns } from "./NegocioAbas.vue?vue&type=template&id=9f9903ec&"
import script from "./NegocioAbas.vue?vue&type=script&lang=js&"
export * from "./NegocioAbas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports